var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gpt-end"},[_c('div',{staticClass:"wrap"},[_c('img',{attrs:{"src":require("@/assets/images/chat_end.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t("GPT.END_SURVEY_MSG")))])]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t("GPT.BACKHOME")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }